
import Webcam from "react-webcam";
import { connect, useDispatch } from 'react-redux';
import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import {
    loadingToggleAction, identificationAction,
} from '../../../store/actions/PatientAction';
import { Link, withRouter } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import { currentUser } from '../../../store/selectors/CurrentUserSelector';

const PatientIdentify = (props) => {
    const { t } = useTranslation();
    const webcamRef = React.useRef(null);
    const dispatch = useDispatch();
    const [imgSrc, setImgSrc] = React.useState(null);
    
    const capture = React.useCallback(() => {
        const imageBase64 = webcamRef.current.getScreenshot();
        if (imageBase64 != null) {
            setImgSrc(imageBase64);
            dispatch(loadingToggleAction(true));
            dispatch(identificationAction(imageBase64, props.history));
        }
    }, [webcamRef,setImgSrc]);
    const reset = () =>{
        setImgSrc("");
    }

    const canDo = (menuCode, actionCode) => {
        let theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
        if(!theMenu){
          return false;
        }else{
          return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
        }
      }
    
     const hasMenu = (menuCode) => {
          return props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
      }

      useEffect(() => {
        if(hasMenu('MENIDENT') && canDo('MENIDENT', 'ACIDENTRF')){
        }else{
            props.history.push("/");
        }
    }, []);

    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item active">
                        <Link to="#">{t('common.patient')}</Link>
                    </li>
                    <li className="breadcrumb-item">
                        <Link to="#">{t('layout.authentication')}</Link>
                    </li>
                </ol>
            </div>
            <div className="authincation h-100 p-meddle">
         <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center">
               <div className="col-md-6">
                  <div className="authincation-content">
                     <div className="row no-gutters">
                        <div className="col-xl-12">
                           <div className="auth-form">
                              <h4 className="text-center mb-4">
                                 {t('patient.authentication-patient')}
                              </h4>
                              <div className="justify-content-center rounded-circle">
                            {props.showLoading ?
                                <img className="mb-3 img-thumbnail"
                                src={imgSrc} alt="client screenshot"
                                />:
                                <Webcam
                                className="img-thumbnail"
                                audio={false}
                                ref={webcamRef}
                                height={"50%"}
                                width={"100%"}
                                screenshotFormat="image/jpeg"
                            />
                            }
                            { props.showLoading && 
                                <Button variant="primary" className="btn btn-primary btn-block mt-2" disabled>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />{' '}
                                    <span className="visually-hidden">{t('patient.authentication-progress')}</span>
                                </Button> }
                            { !props.showLoading &&
                                <button type="submit" className="btn btn-primary btn-block mt-2" onClick={capture}>{t('patient.enter-sms-code')}</button>
                            }

                        </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

        </>
    )
};
const mapStateToProps = (state) => {
    return {
       showLoading: state.patient.showLoading,
       currentUser: currentUser(state)
    };
};
export default withRouter(connect(mapStateToProps)(PatientIdentify));